import React from 'react';
import s from './style.css';
const EmptyContent = ({ icon, text, action }) => {
    return (React.createElement("div", { className: s.container },
        icon,
        React.createElement("p", { className: s.text }, text),
        action));
};
export default EmptyContent;
